import { z } from 'zod';
import { emailSchema } from './primitives.js';

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(8, 'Password must be at least 8 characters').max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z.object({
  token: z.string().min(20).max(200),
  password: z.string().min(8, 'Password must be at least 8 characters').max(200),
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const presignUploadSchema = z.object({
  kind: z.enum(['photoId', 'proofAddress', 'rightToWork', 'niProof']),
  contentType: z
    .string()
    .regex(/^(image\/(png|jpe?g|heic|webp)|application\/pdf)$/, 'Unsupported file type'),
  filename: z.string().min(1).max(200).optional(),
});
export type PresignUploadInput = z.infer<typeof presignUploadSchema>;

export const evisaCheckSchema = z.object({
  shareCode: z
    .string()
    .trim()
    .transform((v) => v.toUpperCase())
    .pipe(z.string().regex(/^[A-Z0-9]{6,20}$/, 'Invalid share code')),
  dob: z.string().regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Enter DOB as dd/mm/yyyy'),
});
export type EvisaCheckInput = z.infer<typeof evisaCheckSchema>;
